import {WebFormModel} from "capitalist-shared/src/core/model";
import axios from "axios";
import moment from "moment";
import {RemoteRequestState} from "@/backoffice/components/pages/taxrules/taxrules";

export interface WalletoRefundPetitionInterface extends Record<string, any>{
  required: boolean
  agreeMode: boolean
}

export interface WalletoRefundApplicationInterface extends Record<string, any> {
  firstname: string | null
  lastname: string | null
  middlename: string | null
  dateofbirth: number | null
  documentType: string | null
  documentNumber: string | null
  address: string | null
  account: string | null
}

export class WalletoRefundApplication implements WalletoRefundApplicationInterface {
  firstname = ''
  lastname = ''
  middlename = ''
  dateofbirth = null
  documentType = 'Passport'
  documentNumber = ''
  address = ''
  account = ''

  get agreeText() {
    try {
      const birthDate = moment.unix(this.dateofbirth).format('D/M/YYYY');
      const nowDate = moment().format('D/M/YYYY');

      return `Полное имя: ${this.fullName} \n` +
        '\n' +
        `Адрес, указанный при заполнении анкеты на получение карты: ${this.address}\n` +
        '\n' +
        `Тип документа, удостоверяющего личность: ${this.documentType}\n` +
        '\n' +
        `Номер документа, удостоверяющего личность: ${this.documentNumber}\n` +
        '\n' +
        'Заявление на возврат средств (и закрытие счета)\n' +
        '\n' +
        `Я, ${this.lastname} ${this.firstname}, дата рождения ${birthDate}, \n` +
        '\n' +
        `настоящим заявлением прошу перевести мои средства, оставшиеся на счете в UAB WALLETO,  на мой счет в системе Capitalist (номер счета ${this.account}) и закрыть счёт в UAB WALLETTO.\n` +
        '\n' +
        `Дата: ${nowDate}`;
    } catch (err) {
      return '';
    }
  }

  get fullName() {
    return [this.firstname, this.middlename, this.lastname].join(' ').replace(/\s/, ' ');
  }
}

export class WalletoBlockingModel extends WebFormModel {

  values: {agree: boolean, postpone: boolean,
    agreeText: string | null, agreeValues: any
  } = {agree: false, postpone: false, agreeText: '', agreeValues: null}

  petition: WalletoRefundPetitionInterface | null = null

  application = new WalletoRefundApplication();

  submitStatus = new RemoteRequestState();

  agree() {
    this.submitStatus.loadStart();
    this.values.agree = true;
    this.values.postpone = false;
    this.values.agreeText = this.application.agreeText;
    this.values.agreeValues = this.application;
    return axios.post('/webapi/cards/walletorefundnotice', {call: 'update', m: this.values}).then((response) => {
      this.petition = response.data.model.petition;
      this._setData(response.data.model);
      this.submitStatus.loadEnd();
      return this.petition;
    }).catch((err) => {
      this.submitStatus.loadError();
      this.checkAxiosError(err);
      throw err;
    });
  }

  rememberCancelForAwhile() {
    this.postpone();
    localStorage.setItem('rememberWalletoBlockingWarningLater', moment().add(60, 'minute').valueOf() + '' as string);
  }

  rememberCancelForAMonth() {
    this.postpone();
    localStorage.setItem('rememberWalletoBlockingWarningLater', moment().add(2, 'months').valueOf() + '' as string);
  }

  checkCancel() {
    const t: number = +Number(localStorage.getItem('rememberWalletoBlockingWarningLater')) || 0;
    if (t && t > 0) {
      const r = t < moment().valueOf();
      if (r) {
        localStorage.removeItem('rememberWalletoBlockingWarningLater');
      }
      return !r;
    } else
      return false;
  }



  postpone() {
    this.values.agree = false;
    this.values.postpone = true;
    return axios.post('/webapi/cards/walletorefundnotice', {call: 'update', m: this.values}).then((response) => {
      this.petition = response.data.model.petition;
      this._setData(response.data.model);
      return this.petition;
    });
  }

  checkStatus() {
    return axios.post('/webapi/cards/walletorefundnotice', {call: 'status'}).then((response) => {
      this.petition = response.data.model.petition;
      this.application = Object.assign( new WalletoRefundApplication(), response.data.model.application);

      this._setData(response.data.model);
      return this.petition;
    });
  }
}
